import { fromJS } from "immutable"
import {
  GET_TWO_FACTOR_AUTH_SUCESS,
  GET_TWO_FACTOR_AUTH_WATCHER,
  PUT_TWO_FACTOR_AUTH_ACTIVE_SUCESS,
  PUT_TWO_FACTOR_AUTH_WATCHER,
} from "./constants"

export const initialState = fromJS({
  twoFactorAuthActive: false,
  isLoading: false,
  loadSwitch: false,
})

function securityReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TWO_FACTOR_AUTH_WATCHER:
      return state.set("isLoading", true)

    case GET_TWO_FACTOR_AUTH_SUCESS:
      return state
        .set("twoFactorAuthActive", action.payload.data.two_factor_auth_active)
        .set("isLoading", false)

    case PUT_TWO_FACTOR_AUTH_WATCHER:
      return state.set("loadSwitch", true)

    case PUT_TWO_FACTOR_AUTH_ACTIVE_SUCESS:
      return state
        .set(
          "twoFactorAuthActive",
          action.payload.config.two_factor_auth_active
        )
        .set("loadSwitch", false)

    default:
      return state
  }
}

export default securityReducer
